import { render, staticRenderFns } from "./shipped.vue?vue&type=template&id=561a7ff8&scoped=true&"
import script from "./shipped.vue?vue&type=script&lang=js&"
export * from "./shipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a7ff8",
  null
  
)

export default component.exports